import {
  ContentWrapper,
  FloatingFormItem,
  InputDecimal,
} from '@/components/_common';
import {
  QuotaionOffersPublicResponse,
  QuotationsOffersPublicFormValues,
} from '@/core/domain/stock/QuotationsOffers/QuotationsOffers.types';
import { applyMask } from '@/utils/mask';
import { cepMask } from '@/utils/mask/commonMasks';
import { Col, Descriptions, Form, Input, Row, Statistic } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import QuotationRequestItemsList from './QuotationRequestItemsList';
import formatterPrice from '@/utils/number/formatterPrice';

interface Props {
  data?: QuotaionOffersPublicResponse;
}

const QuotationsRequest: React.FC<Props> = ({ data }) => {
  const form = Form.useFormInstance<QuotationsOffersPublicFormValues>();
  const items = Form.useWatch('items', form);

  const freight = Form.useWatch('freight', form);
  const [generalValue, setGeneralValue] = useState<number>(0);

  useEffect(() => {
    if (items) {
      setGeneralValue(
        (freight ?? 0) +
          items.reduce(
            (acc, curr) =>
              (acc +=
                (((curr.quantity ?? 0) * (curr.unitCost ?? 0)) / 100) *
                (100 - (curr.discount ?? 0))),
            0,
          ),
      );
    }
  }, [freight, items]);

  return (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <ContentWrapper>
          <Descriptions
            title={`Pedido Cotação: ${data?.result.orderQuote}`}
            bordered
            size="small"
            column={{ xxl: 2, sm: 1 }}
          >
            <Descriptions.Item span={2} label="Responsável">
              {data?.result?.responsible}
            </Descriptions.Item>
            <Descriptions.Item label="Nº Documento">
              {moment(data?.result?.date).format('DD/MM/YYYY')}
            </Descriptions.Item>
            <Descriptions.Item label="Empresa">
              {data?.result?.company.name}
            </Descriptions.Item>
            <Descriptions.Item label="Endereço">
              {data?.result?.company.adress}
            </Descriptions.Item>
            <Descriptions.Item label="Cep">
              {applyMask(data?.result?.company.zipCode, cepMask)}
            </Descriptions.Item>
          </Descriptions>
        </ContentWrapper>
      </Col>

      <Col span={24}>
        <QuotationRequestItemsList
          dataItems={data?.result?.items}
          matrixId={data?.result?.matrixId}
        />
      </Col>

      <Col span={24}>
        <Row gutter={[24, 24]} justify="end">
          <Col lg={4}>
            <FloatingFormItem
              name="freight"
              label="Valor Frete"
              initialValue={0}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col lg={3}>
            <Statistic
              title="Total geral"
              value={generalValue}
              formatter={(value) => formatterPrice(Number(value))}
              valueStyle={{
                color:
                  generalValue > 0
                    ? '#148e28'
                    : generalValue < 0
                    ? '#ba4242'
                    : undefined,
              }}
            />
          </Col>
        </Row>
      </Col>

      <Col span={24} lg={12}>
        <FloatingFormItem name="paymentFormat" label="Forma de pagamento">
          <Input.TextArea rows={3} />
        </FloatingFormItem>
      </Col>

      <Col span={24} lg={12}>
        <FloatingFormItem name="observation" label="Observações">
          <Input.TextArea rows={3} />
        </FloatingFormItem>
      </Col>
    </Row>
  );
};

export default QuotationsRequest;
